import React from "react"
import { Link } from "gatsby"
import { Container, VStack, Heading, Button, Text } from "@chakra-ui/react"

import { Icon } from "../../"

export function Error404() {
  return (
    <Container>
      <VStack spacing={6}>
        <Heading size="3xl" textAlign="center" fontWeight="semibold">
          Sorry, this page doesn&apos;t exist.
        </Heading>

        <Button as={Link} to={"/"} variant="primary" size="md">
          <Text as="span" lineHeight={1} fontWeight="bold">
            Return
          </Text>
          <Icon name="arrowRight" boxSize={5} ml={3} />
        </Button>
      </VStack>
    </Container>
  )
}
